import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ProgressProvider } from './context/ProgressContext';
import { AuthProvider } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import SyncNotification from './components/SyncNotification';
import AuthLoading from './components/AuthLoading';

// Pages
import Home from './pages/Home';
import Topics from './pages/Topics';

// Topic Pages
import DataStructures from './pages/topics/DataStructures';
import BigONotation from './pages/topics/BigONotation';
import ControlFlow from './pages/topics/ControlFlow';
import Recursion from './pages/topics/Recursion';
import Arrays from './pages/topics/Arrays';
import Strings from './pages/topics/Strings';
import Practice from './pages/Practice';
import LinkedLists from './pages/topics/LinkedLists';
import StackQueue from './pages/topics/StackQueue';

// Practice Pages
import ControlFlowPractice from './pages/practice/ControlFlowPractice';
import ControlFlowProblem from './pages/practice/ControlFlowProblem';
import RecursionPractice from './pages/practice/RecursionPractice';
import RecursionProblem from './pages/practice/RecursionProblem';
import ArrayPractice from './pages/practice/ArrayPractice';
import ArrayProblem from './pages/practice/ArrayProblem';
import StringPractice from './pages/practice/StringPractice';
import StringProblem from './pages/practice/StringProblem';
import StackQueuePractice from './pages/practice/StackQueuePractice';
import StackQueueProblem from './pages/practice/StackQueueProblem';
import LinkedListPractice from './pages/practice/LinkedListPractice';
import LinkedListProblem from './pages/practice/LinkedListProblem';

// Quiz Pages
import BigOQuiz from './pages/BigOQuiz';
import DataStructuresQuiz from './pages/DataStructuresQuiz';

function App() {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

  if (!clientId) {
    console.error('Google Client ID is not set in environment variables');
    return <div>Configuration Error</div>;
  }

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <BrowserRouter>
        <AuthProvider>
          <ProgressProvider>
            <div className="min-h-screen bg-gray-50">
              <SyncNotification />
              <Routes>
                <Route path="/login" element={<AuthLoading />} />
                <Route path="/" element={<Home />} />
                <Route path="/topics" element={<Topics />} />
                
                {/* Topic Routes */}
                <Route path="/topic/data-structures" element={<DataStructures />} />
                <Route path="/topic/big-o" element={<BigONotation />} />
                <Route path="/topic/control-flow" element={<ControlFlow />} />
                <Route path="/topic/recursion" element={<Recursion />} />
                <Route path="/topic/arrays" element={<Arrays />} />
                <Route path="/topic/strings" element={<Strings />} />
                <Route path="/topic/linked-lists" element={<LinkedLists />} />
                <Route path="/topic/stack-queue" element={<StackQueue />} />
                <Route path="/practice/:topic" element={<Practice />} />
                
                {/* Practice Routes */}
                <Route path="/practice/control-flow" element={<ControlFlowPractice />} />
                <Route path="/practice/control-flow/:problemId" element={<ControlFlowProblem />} />
                <Route path="/practice/recursion" element={<RecursionPractice />} />
                <Route path="/practice/recursion/:problemId" element={<RecursionProblem />} />
                <Route path="/practice/arrays" element={<ArrayPractice />} />
                <Route path="/practice/arrays/:problemId" element={<ArrayProblem />} />
                <Route path="/practice/strings" element={<StringPractice />} />
                <Route path="/practice/strings/:problemId" element={<StringProblem />} />
                <Route path="/practice/stack-queue" element={<StackQueuePractice />} />
                <Route path="/practice/stack-queue/:problemId" element={<StackQueueProblem />} />
                <Route path="/practice/linked-list" element={<LinkedListPractice />} />
                <Route path="/practice/linked-list/:problemId" element={<LinkedListProblem />} />
                
                {/* Quiz Routes */}
                <Route path="/quiz/big-o" element={<BigOQuiz />} />
                <Route path="/quiz/data-structures" element={<DataStructuresQuiz />} />
              </Routes>
            </div>
          </ProgressProvider>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  );
}

export default App;
